import { create } from 'zustand';

export type ConnectionStatus =
  | 'idle'
  | 'connecting'
  | 'connected'
  | 'reconnecting'
  | 'disconnected';

interface ConnectionState {
  status: ConnectionStatus;
  isOnline: boolean;
  lastConnectedAt: number | null;
  reconnectAttempt: number;
  error: string | null;

  setStatus: (status: ConnectionStatus) => void;
  markOnline: () => void;
  markOffline: () => void;
  setError: (error: string | null) => void;
  announceOnline: () => Promise<void>;
  reset: () => void;
}

const initialState = {
  status: 'idle' as ConnectionStatus,
  isOnline: false,
  lastConnectedAt: null as number | null,
  reconnectAttempt: 0,
  error: null as string | null,
};

export const useConnectionStore = create<ConnectionState>((set) => ({
  ...initialState,

  setStatus: (status) =>
    set((s) => ({
      status,
      lastConnectedAt: status === 'connected' ? Date.now() : s.lastConnectedAt,
      reconnectAttempt: status === 'reconnecting' ? s.reconnectAttempt + 1 : s.reconnectAttempt,
    })),

  markOnline: () => set({ isOnline: true, error: null }),

  markOffline: () => set({ isOnline: false }),

  setError: (error) => set({ error }),

  announceOnline: async () => {
    const { announceUserPresence } = await import('../utils/presenceSync');
    await announceUserPresence();
  },

  reset: () => set(initialState),
}));
